import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'

export default {
  VueCtkDateTimePicker
}



// WEBPACK FOOTER //
// ./src/app/dweller/access/form/resources/components.js